import ReactDOM from 'react-dom/client'
import App from '@/App'
import '@/styles/index.css'

const app = <App />

ReactDOM.createRoot(document.getElementById('root')!).render(app)

